import React from 'react'
import InterviewScheduleTable from './Calender/InterviewScheduleTable'
import CustomCalendar from './Calender/CustomCalendar'

export default function Calender() {
  return (
    <div>
      <InterviewScheduleTable />
      {/* <CustomCalendar /> */}
    </div>
  )
}
